/**
 * Key of the page wrapper in DashboardLayout (fade-in animation + error-boundary
 * reset on navigation). A route rendered as a RouteModal (`handle.routeModal`)
 * opens OVER its parent page, so the key stays the parent's pathname: the list
 * under the modal keeps its state (view mode, scroll, filters) and is not
 * re-mounted / re-fetched when the detail opens or closes (prod deep-test
 * AIT-153 / AIT-190: /projects table view reset after closing /projects/:id).
 */
export interface KeyMatch {
  pathname: string;
  handle?: unknown;
}

const isRouteModal = (m: KeyMatch): boolean =>
  !!m.handle && typeof m.handle === 'object' && (m.handle as { routeModal?: unknown }).routeModal === true;

export function pageKeyOf(matches: readonly KeyMatch[], pathname: string): string {
  const i = matches.findIndex(isRouteModal);
  if (i <= 0) return pathname;
  return matches[i - 1].pathname.replace(/\/+$/, '') || '/';
}
